export const CREATE_USER_LIVE_SESSION = "CREATE_USER_LIVE_SESSION";
export const CREATE_USER_LIVE_SESSION_SUCCESS = "CREATE_USER_LIVE_SESSION_SUCCESS";
export const CREATE_USER_LIVE_SESSION_ERROR = "CREATE_USER_LIVE_SESSION_ERROR";
export const FINISH_USER_LIVE_SESSION = "FINISH_USER_LIVE_SESSION";
export const FINISH_USER_LIVE_SESSION_SUCCESS = "FINISH_USER_LIVE_SESSION_SUCCESS";
export const FINISH_USER_LIVE_SESSION_ERROR = "FINISH_USER_LIVE_SESSION_ERROR";
